import React from 'react';
import pt from 'prop-types';

import Status from 'components/status';
import { getPartnerDirectoryURL } from 'utils/partner';
import Button from 'components/button';

import './directory-listing-card.scss';

// `rejected` is not surfaced in the portal yet, so it presents as `not_listed`.
const CARD_STATES = Object.freeze({
  not_listed: Object.freeze({
    label: 'Not listed',
    statusType: 'muted',
    action: 'Submit profile',
    alwaysEnabled: true,
  }),
  rejected: Object.freeze({
    label: 'Not listed',
    statusType: 'muted',
    action: 'Submit profile',
    alwaysEnabled: true,
  }),
  pending: Object.freeze({
    label: 'Under review',
    statusType: 'warning',
    action: 'Submit changes',
    alwaysEnabled: false,
  }),
  listed: Object.freeze({
    label: 'Listed',
    statusType: 'positive',
    action: 'Publish changes',
    alwaysEnabled: false,
  }),
});

export default function DirectoryListingCard({
  status = 'not_listed',
  edited = false,
  onClickAction,
  onClickCriteria,
}) {
  const state = CARD_STATES[status] || CARD_STATES.not_listed;
  const isListed = status === 'listed';
  const disabled = !state.alwaysEnabled && !edited;

  return (
    <div className="directory-listing-card">
      <div className="directory-listing-card-body">
        <div className="directory-listing-card-heading">
          <h3>Partner listing</h3>
          <Status type={state.statusType} size="sm">
            {state.label}
          </Status>
        </div>

        <p className="directory-listing-card-description">
          {isListed ? (
            <>
              Your profile is currently listed in our{' '}
              <a
                className="directory-listing-card-link"
                href={getPartnerDirectoryURL()}
                target="_blank"
                rel="noreferrer"
              >
                Partner directory
              </a>
              .
            </>
          ) : (
            <>
              You can submit your profile to get featured on our{' '}
              <a
                className="directory-listing-card-link"
                href={getPartnerDirectoryURL()}
                target="_blank"
                rel="noreferrer"
              >
                Partner directory
              </a>
              . Once submitted, our team reviews it and you&rsquo;ll be notified
              by email if it&rsquo;s approved to go live. Make sure you meet our{' '}
              <button
                type="button"
                className="directory-listing-card-link"
                onClick={onClickCriteria}
              >
                listing criteria
              </button>{' '}
              before submitting.
            </>
          )}
        </p>
      </div>

      <Button
        type={disabled ? 'secondary' : 'default'}
        disabled={disabled}
        onClick={onClickAction}
      >
        {state.action}
      </Button>
    </div>
  );
}

DirectoryListingCard.propTypes = {
  status: pt.oneOf(['not_listed', 'pending', 'listed', 'rejected']),
  edited: pt.bool,
  onClickAction: pt.func,
  onClickCriteria: pt.func,
};
